/** 旧「AI组图 / AI智能组图」用户文案 → 「主图创作」（含已落库的步骤预览标签） */
const LEGACY_GOODS_STUDIO_REPLACEMENTS = [
  [/AI\s*智能组图/g, '主图创作'],
  [/AI\s*组图产出/g, '主图创作'],
  [/AI\s*组图/g, '主图创作'],
];

export function rewriteLegacyGoodsStudioUserCopy(text) {
  let value = String(text ?? '');
  if (!value) return value;
  LEGACY_GOODS_STUDIO_REPLACEMENTS.forEach(([pattern, next]) => {
    value = value.replace(pattern, next);
  });
  return value;
}

export function isLegacyGoodsStudioLabel(label) {
  const value = String(label || '').trim();
  if (!value) return false;
  return /AI\s*智能组图|AI\s*组图/.test(value);
}
